import SeoArticlePage from '@/pages/article/SeoArticlePage';
import { shippingArticle } from '@/mocks/articles';

export default function ShippingPage() {
  return <SeoArticlePage article={shippingArticle} />;
}